const FichaTecnica = (props) => {
  const { caracteristicas, ciudad, datoExtra, departamento, equipoLider, institucion, tipoInstitucion, totalEstudiantes, grados } = props;
  return (
    <div className="fondo-ficha-tecnica img-repeat-x">
      <div className="contenido">
        <div className="mx-auto w-10/12 lg:w-7/12 3xl:w-8/12 ">

          <div className="bg-azul p-3 w-80 rounded-22">
            <h1 className="poppins-400 text-blanco text-18 alineado-verticalmente">
              <span className="icon-bonbillo text-38"></span>
              Ficha técnica del proyecto
            </h1>
          </div>


          <div className="flex justify-between mt-10">
            <div className="hidden lg:block w-1/12">
              <div className=" w-20 h-20 bg-blanco center rounded-full">
                <img className="w-8/12 " src={require(`../../images/iconos-historia/institucion.svg`).default} alt="icono de institucion" />
              </div>
            </div>
            <div className="lg:w-10/12 ">
              <h2 className="poppins-700 text-40">{institucion}</h2>
              <p className="py-5 text-30 alineado-verticalmente lato-700">
                <span className="icon-ubicacion mr-3"></span>
                {ciudad}, {departamento}
              </p>
              <p className="text-22 lato-400 mt-3 mb-10">
                <span className="lato-900">Institución {tipoInstitucion}: </span>
                {caracteristicas}
              </p>

              <div className="grid md:grid-cols-3 gap-10">
                <div>
                  <img className="mx-auto md:mx-0  w-40 md:w-6/12" src={require(`../../images/iconos-historia/estudiantes.svg`).default} alt="estudiantes" />
                  <p className="text-center md:text-left lato-900  leading-snug mt-10 text-20">Total <br /> estudiantes:</p>
                  <p className="text-center md:text-left lato-300  text-40">{totalEstudiantes}</p>
                </div>
                <div>
                  <img className="mx-auto md:mx-0 w-40 md:w-6/12" src={require(`../../images/iconos-historia/equipo-lider.svg`).default} alt="equipo lider" />
                  <p className="text-center md:text-left lato-900 mt-10 text-20 ">Equipo <br /> líder:</p>
                  <p className="text-center md:text-left lato-300 text-40">{equipoLider}</p>
                  {grados &&
                    <p className="text-center md:text-left lato-300 text-20 leading-snug">{grados}</p>
                  }
                </div>
                <div >
                  <img className="mx-auto md:mx-0  w-40 md:w-4/12" src={require(`../../images/iconos-historia/asterisco.svg`).default} alt="asterisco" />
                  <p className="text-center md:text-left lato-900 leading-snug mt-10 text-20">{datoExtra}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  )
}

export default FichaTecnica;